import { ChevronDown, ChevronUp } from '@repo/ui/components/icon';
import { cn } from '@repo/ui/lib/utils';
import { useState } from 'react'
import SectionChild from '~/components/SectionChild';

function ContentPage({ content }: { content?: string }) {
  const [open, setOpen] = useState(false);
  return (
    content && (
      <div className="pb-10">
        <SectionChild
          className={
            " border-l-4 bg-[#F0F9F9] border-primary flex flex-col gap-4"
          }
        >
          <div
            className={cn(
              "py-10 overflow-hidden relative px-10 pb-10",
              open ? "h-full" : "h-[200px]"
            )}
          >
            {!open && (
              <div className="absolute w-full h-full bg-overlay-third"></div>
            )}

            <div
              className="max-w-full prose ck-content"
              dangerouslySetInnerHTML={{
                __html: content || "",
              }}
            ></div>
          </div>
          <div className="px-10 pb-10">
            <div
              className="flex items-center font-sans font-bold cursor-pointer text-primary"
              onClick={() => setOpen(!open)}
            >
              {open ? "Rút gọn" : "Xem thêm"}
              {open ? <ChevronUp /> : <ChevronDown />}
            </div>
          </div>
        </SectionChild>
      </div>
    )
  );
}

export default ContentPage
